document.addEventListener("DOMContentLoaded", () => {
  // =============================================
  // 1. STATE MANAGEMENT
  // =============================================
  const state = {
    editedCard1: null,
    editedCard2: null,
    notes: null,
    enhance: "No",
    material: "Standard",
    quantity: "Standard 2 Pack",
    customizeBack: false,
    extraForBack: 0,
    price: 0,
    card1: {
      image: null,
      imageUrl: null,
      chipSize: "Large Chip",
      imageTransform: null,
    },
    card2: {
      image: null,
      imageUrl: null,
      strip: "No Strip",
      imageTransform: null,
    },
    currentCard: 1,
  };
  let designer = null;

  // =============================================
  // 2. PRICE VARIANTS
  // =============================================
  const PRICE_VARIANTS = {
    enhance: [
      { value: "No", price: 0.0 },
      { value: "Yes", price: 2.0 },
    ],
    material: [
      { value: "Standard", price: 0.0 },
      { value: "Holographic", price: 3.0 },
    ],
    quantity: [
      { value: "Standard 2 Pack", price: 0.0 },
      { value: "4 Pack", price: 2.0 },
      { value: "8 Pack", price: 4.0 },
      { value: "10 Pack", price: 6.0 },
      { value: "20 Pack", price: 10.0 },
    ],
  };
  const BASE_PRICE = 9.99;
  const EXTRA_BACK_PRICE = 5.0;

  const FORMAT_ICONS = {
    pdf: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pdf-file.png",
    ai: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/ai-file.png",
    eps: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/eps-file.png",
    tiff: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tif-file.png",
  };

  const NON_EDITABLE_EXTS = ["pdf", "ai", "eps", "tiff", "psd"];

  // =============================================
  // 3. HELPER FUNCTIONS
  // =============================================
  function show(el) {
    if (el) el.style.display = "";
  }
  function hide(el) {
    if (el) el.style.display = "none";
  }
  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }
  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  function isCardCustomized(cardState) {
    return cardState.image || cardState.imageUrl;
  }

  function disableBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.dataset.scrollY = scrollY;
  }

  function enableBodyScroll() {
    const scrollY = document.body.dataset.scrollY || 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute("data-scrollY");
  }

  function findScrollableParent(el) {
    while (el) {
      const style = window.getComputedStyle(el);
      const overflow = style.overflow || style.overflowY;
      if (overflow === "auto" || overflow === "scroll") {
        if (el.scrollHeight > el.clientHeight) {
          return el;
        }
      }
      el = el.parentElement;
    }
    return document.documentElement;
  }

  // =============================================
  // 4. IMAGE UPLOAD HANDLING
  // =============================================
  const isDisplayableImage = (file) => {
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    return NON_EDITABLE_EXTS.includes(ext) || file.type === "application/pdf";
  };

  function bindUploadForCard(card) {
    const suf = card === 1 ? "c1" : "c2";
    const fileInput = document.getElementById(`upload-file-image-${suf}`);
    const chooseBtn = document.getElementById(`choose-file-btn-image-${suf}`);
    const artbox = document.getElementById(`upload-artbox-image-${suf}`);
    const previewBox = document.getElementById(`preview-box-image-${suf}`);
    const previewImg = document.getElementById(`preview-image-image-${suf}`);
    const deleteBtn = document.getElementById(`delete-image-${suf}`);
    const errorMsg = document.getElementById(`upload-file-error-image-${suf}`);
    if (
      !fileInput ||
      !chooseBtn ||
      !artbox ||
      !previewBox ||
      !previewImg ||
      !deleteBtn ||
      !errorMsg
    )
      return;

    const freshChoose = chooseBtn.cloneNode(true);
    const freshInput = fileInput.cloneNode(true);
    chooseBtn.replaceWith(freshChoose);
    fileInput.replaceWith(freshInput);

    freshChoose.addEventListener("click", (e) => {
      e.preventDefault();
      freshInput.click();
    });

    freshInput.addEventListener("change", (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const allowed = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/svg+xml",
      ];
      if (!allowed.includes(file.type)) {
        errorMsg.textContent = "Please upload .jpg, .jpeg, .png, .webp or .svg";
        errorMsg.classList.add("active");
        freshInput.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = (ev) => {
        previewImg.src = ev.target.result;
        artbox.style.display = "none";
        previewBox.style.display = "block";
        errorMsg.classList.remove("active");

        designer.handleImageUpload({ target: { files: [file] } }, card);
      };
      reader.readAsDataURL(file);
    });

    deleteBtn.addEventListener("click", () => {
      freshInput.value = "";
      artbox.style.display = "block";
      previewBox.style.display = "none";
      previewImg.src = "";
      errorMsg.classList.remove("active");

      const cs = state[`card${card}`];
      cs.image = null;
      cs.imageUrl = null;
      cs.imageTransform = null;

      if (state.currentCard === card && designer?.backgroundImage) {
        designer.canvas.remove(designer.backgroundImage);
        designer.backgroundImage = null;
        designer.canvas.renderAll();
        designer.updateFinishButtonState();
      }
    });
  }

  // =============================================
  // 5. CHIP SIZE AND STRIP SELECTION
  // =============================================
  function setupChipSizeSelection() {
    const variant = document.getElementById("chip-size-variant-c1");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
        el.setAttribute("aria-pressed", String(el === selected));
      });
      const value = selected.dataset.chipSize || "Large Chip";
      state.card1.chipSize = value;
      if (state.currentCard === 1) {
        designer.updateChipSize(value);
      }
    });
  }

  function setupStripSelection() {
    const variant = document.getElementById("strip-variant-c2");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.strip || "No Strip";
      state.card2.strip = value;
      if (state.currentCard === 2) {
        designer.updateStrip(value);
      }
    });
  }

  // =============================================
  // 6. ENHANCE, MATERIAL, AND QUANTITY SELECTION
  // =============================================
  function setupEnhanceSelection() {
    const variant = document.getElementById("enhance-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.enhance || "No";
      state.enhance = value;
      recalcPrice();
    });
  }

  function setupMaterialSelection() {
    const variant = document.getElementById("material-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.material || "Standard";
      state.material = value;
      recalcPrice();
    });
  }

  function setupQuantitySelection() {
    const variant = document.getElementById("quantity-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.quantity || "Standard 2 Pack";
      state.quantity = value;
      recalcPrice();
    });
  }

  // =============================================
  // 7. NOTES HANDLING
  // =============================================
  function handleNotesInput() {
    const input = document.getElementById("notes-input");
    const counter = document.getElementById("notes-char-count");
    if (!input || !counter) return;
    const MAX = 200;
    const refresh = () => {
      if (input.value.length > MAX) {
        input.value = input.value.slice(0, MAX);
      }
      state.notes = input.value;
      const remaining = MAX - input.value.length;
      counter.textContent = `${remaining} character(s) left`;
    };
    refresh();
    input.addEventListener("input", refresh);
  }

  // =============================================
  // 8. PRICE CALCULATION
  // =============================================
  function recalcPrice() {
    let total = BASE_PRICE;
    total += priceOf("enhance", state.enhance) || 0;
    total += priceOf("material", state.material) || 0;
    total += priceOf("quantity", state.quantity) || 0;
    total += state.extraForBack;
    total = Math.round(total * 100) / 100;
    const priceEl = document.getElementById("pcs-final-price");
    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;
      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }
    state.price = total;
  }

  // =============================================
  // 9. DELETE PREVIEW
  // =============================================
  const deleteBannerImage = document.getElementById("delete-banner-image");
  deleteBannerImage.addEventListener("click", (e) => {
    e.preventDefault();

    resetSidebarVariants();

    if (designer) {
      designer.handleRemoveAllImproved();
    }

    state.currentCard = 1;

    document.querySelectorAll(".card-tab").forEach((tab) => {
      const cardNum = parseInt(tab.dataset.card, 10);
      tab.classList.toggle("active", cardNum === 1);
    });

    document.getElementById("image-variant-c1").style.display = "";
    document.getElementById("variants-c1").style.display = "";
    document.getElementById("image-variant-c2").style.display = "none";
    document.getElementById("variants-c2").style.display = "none";

    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const uploadArtbox = document.getElementById("upload-artbox");
    const btnEditImage = document.getElementById("btnEditImage");

    if (previewBox) {
      previewBox.style.display = "none";
      previewBox.classList.remove("non-editable-image");
    }
    if (mainVariants) mainVariants.classList.remove("active");
    if (uploadArtbox) uploadArtbox.style.display = "block";
    if (btnEditImage) btnEditImage.style.display = "inline";

    const previewImage1 = document.getElementById("preview-image1");
    const previewImage2 = document.getElementById("preview-image2");
    if (previewImage1) previewImage1.src = "";
    if (previewImage2) previewImage2.src = "";
    const preview2Wrap = document.querySelector(".card-preview2");
    if (preview2Wrap) preview2Wrap.style.display = "none";

    if (designer) {
      designer.renderCardFromState(1);
    }
  });

  // =============================================
  // 10. RESET SIDEBAR VARIANTS
  // =============================================
  function resetSidebarVariants() {
    ["c1", "c2"].forEach((suf) => {
      const fileInput = document.getElementById(`upload-file-image-${suf}`);
      const artbox = document.getElementById(`upload-artbox-image-${suf}`);
      const previewBox = document.getElementById(`preview-box-image-${suf}`);
      const previewImg = document.getElementById(`preview-image-image-${suf}`);
      const errorMsg = document.getElementById(
        `upload-file-error-image-${suf}`
      );

      if (fileInput) fileInput.value = "";
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      if (previewImg) previewImg.src = "";
      if (errorMsg) errorMsg.classList.remove("active");
    });

    state.card1 = {
      image: null,
      imageUrl: null,
      chipSize: "Large Chip",
      imageTransform: null,
    };

    state.card2 = {
      image: null,
      imageUrl: null,
      strip: "No Strip",
      imageTransform: null,
    };

    state.editedCard1 = null;
    state.editedCard2 = null;
    state.customizeBack = false;
    state.extraForBack = 0;

    ["chip-size-variant-c1", "strip-variant-c2"].forEach((id) => {
      const variant = document.getElementById(id);
      if (variant) {
        const items = variant.querySelectorAll(".sticker-variant");
        items.forEach((el) => {
          el.classList.remove("active");
          if (id === "chip-size-variant-c1") el.setAttribute("aria-pressed", "false");
        });
        if (items.length) {
          items[0].classList.add("active");
          if (id === "chip-size-variant-c1") {
            items[0].setAttribute("aria-pressed", "true");
            state.card1.chipSize = items[0].dataset.chipSize || "Large Chip";
            if (designer && state.currentCard === 1) {
              designer.updateChipSize(state.card1.chipSize);
            }
          } else if (id === "strip-variant-c2") {
            state.card2.strip = items[0].dataset.strip || "No Strip";
            if (designer && state.currentCard === 2) {
              designer.updateStrip(state.card2.strip);
            }
          }
        }
      }
    });

    ["enhance", "material", "quantity"].forEach((key) => {
      const variant = document.getElementById(`${key}-variant`);
      if (variant) {
        const items = variant.querySelectorAll(".sticker-variant");
        items.forEach((el) => el.classList.remove("active"));
        if (items.length) {
          items[0].classList.add("active");
          state[key] = items[0].dataset[key] || PRICE_VARIANTS[key][0].value;
        }
      }
    });

    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));

    recalcPrice();

    if (designer) {
      designer.updateChipSize("Large Chip");
      designer.updateStrip("No Strip");
    }
  }

  // =============================================
  // 11. FORM VALIDATION
  // =============================================
  function validateForm() {
    let firstInvalid = null;
    function toggleError(id, show, message = "") {
      const bar = document.getElementById(id);
      if (!bar) return;
      if (message) bar.textContent = message;
      bar.style.display = show ? "block" : "none";
      const variantBox = bar.closest(".pcs-variant");
      if (variantBox) variantBox.classList.toggle("has-error", show);
      if (show && !firstInvalid) firstInvalid = variantBox || bar;
    }

    const cardState = state[`card${state.currentCard}`];
    if (!cardState.imageUrl && state.currentCard === 1) {
      toggleError(
        "upload-file-error-image-c1",
        true,
        "Please upload an image for the front side."
      );
    } else {
      toggleError("upload-file-error-image-c1", false);
    }

    if (state.customizeBack && !cardState.imageUrl && state.currentCard === 2) {
      toggleError(
        "upload-file-error-image-c2",
        true,
        "Please upload an image for the back side."
      );
    } else {
      toggleError("upload-file-error-image-c2", false);
    }

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }

  // =============================================
  // 12. ADD TO CART FUNCTIONALITY
  // =============================================
  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn) return;
    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }
      console.log("Form valid – adding to cart:", state);
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
        <div class="pcs-loader"></div>
        <p class="pcs-message"></p>
        <div class="dot-falling"></div>
      `;
      const messageEl = addToCartBtn.querySelector(".pcs-message");
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;
      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await deleteText(messageEl);
          messageIndex++;
        }
      };
      startTypingLoop();
      const loadingBar = addToCartBtn.querySelector(".pcs-loader");
      let progress = 0;
      const target = 99;
      const interval = setInterval(() => {
        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }
        loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
      }, 80);
      try {
        state.extraForBack = state.customizeBack ? EXTRA_BACK_PRICE : 0;
        recalcPrice();

        const card2Active =
          state.customizeBack && isCardCustomized(state.card2);

        const requestData = {
          calculatorId: "5a96b67d057b4",
          productId: 7752183939120,
          properties: {
            "Front Image": state.card1.image?.name || "",
            "Back Image": card2Active ? state.card2.image?.name || "" : "",
            "Front Edited": state.editedCard1?.name || "",
            "Back Edited": card2Active
              ? state.editedCard2?.name || ""
              : "Same as Front",
            "Chip Size": state.card1.chipSize,
            "Does Your Card Have a Strip?": card2Active
              ? state.card2.strip
              : "No Strip",
            "Enhance Image": state.enhance,
            Material: state.material,
            Quantity: state.quantity,
            "Instructions or Notes": state.notes || "",
            "Is Back?": card2Active ? "Yes" : "No",
          },
        };
        console.log("Request Data: ", requestData);
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          }
        );
        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
        if (state.card1.image) {
          formData.append("properties[Front Image]", state.card1.image);
        }
        if (state.customizeBack && state.card2.image) {
          formData.append("properties[Back Image]", state.card2.image);
        }
        if (state.editedCard1) {
          formData.append("properties[Front Edited]", state.editedCard1);
        }
        if (state.customizeBack && state.editedCard2) {
          formData.append("properties[Back Edited]", state.editedCard2);
        }
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartAddJson = await cartAddRes.json();
        console.log("Add to Cart Response:", cartAddJson);
        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");
        const cartJson = {
          items: [cartAddJson],
          item_count: 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };
        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());
        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }
        setTimeout(() => {
          const lineItems = cartDrawer.querySelectorAll("line-item");
          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );
            if (!desktopPriceContainer && !mobilePriceContainer) return;
            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);
            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }
            if (isFree && variantId == shopifyVariantId) {
              const matchingItem = cartJson.items.find(
                (item) => String(item.id) === variantId
              );
              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);
                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper"
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image"
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title"
                );
                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img"
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `
                      <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                    `;
                  }
                }
                if (productTitle.textContent.trim() === "") {
                  productTitle.textContent = document.querySelector(
                    ".product__info .product-meta__title"
                  ).textContent;
                }
                const updatedPriceHTML = `
                  <span class="visually-hidden">Sale price</span>
                  $${correctPrice}
                `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 300);
        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);
        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;
          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => {
            confetti.remove();
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = "Add to Cart";
        stopTypingLoop = true;
        resetSidebarVariants();
        const notes = document.getElementById("notes-input");
        if (notes) {
          notes.value = "";
          state.notes = null;
          const notesCount = document.getElementById("notes-char-count");
          if (notesCount) notesCount.textContent = "200 character(s) left";
        }
        const variants = ["enhance", "material", "quantity"];
        variants.forEach((key) => {
          const variant = document.getElementById(`${key}-variant`);
          if (variant) {
            const items = variant.querySelectorAll(".sticker-variant");
            items.forEach((el) => el.classList.remove("active"));
            if (items.length) {
              items[0].classList.add("active");
              state[key] =
                items[0].dataset[key] || PRICE_VARIANTS[key][0].value;
            }
          }
        });
        state.currentCard = 1;
        document.querySelectorAll(".card-tab").forEach((tab) => {
          const cardNum = parseInt(tab.dataset.card, 10);
          tab.classList.toggle("active", cardNum === 1);
        });
        document.getElementById("image-variant-c1").style.display = "";
        document.getElementById("variants-c1").style.display = "";
        document.getElementById("image-variant-c2").style.display = "none";
        document.getElementById("variants-c2").style.display = "none";
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const uploadArtbox = document.getElementById("upload-artbox");
        const btnEditImage = document.getElementById("btnEditImage");
        if (previewBox) {
          previewBox.style.display = "none";
          previewBox.classList.remove("non-editable-image");
        }
        if (mainVariants) mainVariants.classList.remove("active");
        if (uploadArtbox) uploadArtbox.style.display = "block";
        if (btnEditImage) btnEditImage.style.display = "inline";
        const previewImage1 = document.getElementById("preview-image1");
        const previewImage2 = document.getElementById("preview-image2");
        if (previewImage1) previewImage1.src = "";
        if (previewImage2) previewImage2.src = "";
        const preview2Wrap = document.querySelector(".card-preview2");
        if (preview2Wrap) preview2Wrap.style.display = "none";

        if (designer) {
          designer.handleRemoveAllImproved();
          designer.renderCardFromState(1);
        }
      }
    });
  }

  // Text animation helpers
  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      let i = 0;
      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;
        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }
  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);
        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  // =============================================
  // 13. CARD SWITCHING
  // =============================================
  function handleCustomizeBackModal(resolve) {
    const customizeBackModal = document.getElementById("customize-back-popup");
    const cancelCustomize = document.getElementById("cancel-customize-back");
    const confirmCustomize = document.getElementById("confirm-customize-back");

    if (!customizeBackModal || !cancelCustomize || !confirmCustomize) {
      console.error("Modal or buttons not found");
      resolve(false);
      return;
    }

    customizeBackModal.classList.add("active");
    disableBodyScroll();

    cancelCustomize.addEventListener(
      "click",
      () => {
        customizeBackModal.classList.remove("active");
        enableBodyScroll();
        resolve(false);
      },
      { once: true }
    );

    confirmCustomize.addEventListener(
      "click",
      () => {
        customizeBackModal.classList.remove("active");
        document
          .querySelector(".sidebar")
          .scrollTo({ top: 0, behavior: "smooth" });
        enableBodyScroll();
        resolve(true);
      },
      { once: true }
    );
  }

  function setupCardSwitching() {
    const tabs = document.querySelectorAll(".card-tab");

    tabs.forEach((tab) => {
      tab.addEventListener("click", async (e) => {
        const newCard = parseInt(e.currentTarget.dataset.card, 10);
        if (newCard === state.currentCard) return;

        saveCurrentCardState();

        if (newCard === 2 && !state.customizeBack) {
          const confirmed = await new Promise((resolve) => {
            handleCustomizeBackModal(resolve);
          });

          if (!confirmed) return;

          state.customizeBack = true;
          state.extraForBack = EXTRA_BACK_PRICE;
          state.card2 = {
            image: null,
            imageUrl: null,
            strip: "No Strip",
            imageTransform: null,
          };
          document.getElementById("image-variant-c2").style.display = "";
          document.getElementById("variants-c2").style.display = "";
          recalcPrice();
        }

        state.currentCard = newCard;
        document.getElementById("image-variant-c1").style.display =
          newCard === 1 ? "" : "none";
        document.getElementById("image-variant-c2").style.display =
          newCard === 2 && state.customizeBack ? "" : "none";
        document.getElementById("variants-c1").style.display =
          newCard === 1 ? "" : "none";
        document.getElementById("variants-c2").style.display =
          newCard === 2 && state.customizeBack ? "" : "none";

        document
          .querySelectorAll(".card-tab")
          .forEach((t) =>
            t.classList.toggle(
              "active",
              parseInt(t.dataset.card, 10) === newCard
            )
          );

        await designer.renderCardFromState(newCard);
        loadCurrentCardState();
      });
    });
  }

  function saveCurrentCardState() {
    const suf = state.currentCard === 1 ? "c1" : "c2";
    const cardState = state[`card${state.currentCard}`];

    const chipSizeVariant = document.getElementById("chip-size-variant-c1");
    if (chipSizeVariant && state.currentCard === 1) {
      const sel = chipSizeVariant.querySelector(
        ".sticker-variants__list .sticker-variant.active"
      );
      if (sel) cardState.chipSize = sel.dataset.chipSize || "Large Chip";
    }

    const stripVariant = document.getElementById("strip-variant-c2");
    if (stripVariant && state.currentCard === 2) {
      const sel = stripVariant.querySelector(
        ".sticker-variants__list .sticker-variant.active"
      );
      if (sel) cardState.strip = sel.dataset.strip || "No Strip";
    }

    if (designer && designer.backgroundImage) {
      if (typeof designer.backgroundImage.getSrc === "function") {
        cardState.imageUrl = designer.backgroundImage.getSrc();
      }
      cardState.imageTransform = designer._snapshotObj(
        designer.backgroundImage
      );
    } else if (!cardState.imageUrl) {
      cardState.imageUrl = null;
      cardState.imageTransform = null;
    }
  }

  function syncSidebarToCardState(cardIndex) {
    const cs = state[`card${cardIndex}`];

    const suf = cardIndex === 1 ? "c1" : "c2";
    const artbox = document.getElementById(`upload-artbox-image-${suf}`);
    const previewBox = document.getElementById(`preview-box-image-${suf}`);
    const previewImg = document.getElementById(`preview-image-image-${suf}`);

    if (cs.imageUrl) {
      if (artbox) artbox.style.display = "none";
      if (previewBox) previewBox.style.display = "block";
      if (previewImg) previewImg.src = cs.imageUrl;
    } else {
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      if (previewImg) previewImg.src = "";
    }

    if (cardIndex === 1) {
      const chipSizeVariant = document.getElementById("chip-size-variant-c1");
      if (chipSizeVariant) {
        const items = chipSizeVariant.querySelectorAll(".sticker-variant");
        items.forEach((el) => {
          const selected = el.dataset.chipSize === cs.chipSize;
          el.classList.toggle("active", selected);
          el.setAttribute("aria-pressed", String(selected));
        });
      }
    } else if (cardIndex === 2) {
      const stripVariant = document.getElementById("strip-variant-c2");
      if (stripVariant) {
        const items = stripVariant.querySelectorAll(".sticker-variant");
        items.forEach((el) =>
          el.classList.toggle("active", el.dataset.strip === cs.strip)
        );
      }
    }

    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));
  }

  function loadCurrentCardState() {
    const idx = state.currentCard;
    const cs = state[`card${idx}`];

    syncSidebarToCardState(idx);

    if (designer) {
      designer.canvas.clear();
      designer.canvas.clipPath = null;
      designer.backgroundRect = null;
      designer.backgroundImage = null;
      designer.chipImage = null;
      designer.stripRect = null;
      designer.guidelineObjects = [];

      designer.drawClipPath();

      if (cs.imageUrl) {
        fabric.Image.fromURL(
          cs.imageUrl,
          (img) => {
            designer._placeImage(img, cs.imageTransform);
            designer.canvas.renderAll();
          },
          { crossOrigin: "anonymous" }
        );
      }

      if (idx === 1) {
        designer.updateChipSize(cs.chipSize || "Large Chip");
      } else if (idx === 2) {
        designer.updateStrip(cs.strip || "No Strip");
      }

      designer.canvas.renderAll();
      designer.updateFinishButtonState();
    }
  }

  // =============================================
  // 14. CARD DESIGNER CLASS
  // =============================================
  class CardDesigner {
    constructor() {
      this.canvas = null;
      this.clipPath = null;
      this.backgroundRect = null;
      this.backgroundImage = null;
      this.chipImage = null;
      this.stripRect = null;
      this.guidelineObjects = [];
      this.freezeLayout = false;
      this._renderToken = 0;
      this.snappingEnabled = true;
      this._ro = null;
      this.icons = {
        resizeLeft:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-left.webp",
        resizeRight:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-right.webp",
        resizeHorizontal:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-horizontal.webp",
        stackUp:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackup.webp",
        stackDown:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackdown.webp",
        rotate:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rotate.webp",
      };
      this.init();
    }

    init() {
      const canvasContainer = document.getElementById("canvasContainer");
      if (!canvasContainer) {
        console.error("Canvas container not found");
        return;
      }

      canvasContainer.innerHTML = '<canvas id="stickerCanvas"></canvas>';
      this.canvas = new fabric.Canvas("stickerCanvas", {
        width: canvasContainer.offsetWidth,
        height: canvasContainer.offsetHeight,
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
        backgroundColor: "white",
      });

      this.setupCanvas();
      this.setupEventListeners();
      this.setupCustomControls();
      this.observeContainerResize(canvasContainer);
      this.updateCanvasSize();
      this.drawClipPath(); // Ensure clip path is drawn on init
      this.updateFinishButtonState();
    }

    observeContainerResize(container) {
      const ro = new ResizeObserver(debounce(() => this.handleResize(), 120));
      ro.observe(container);
      this._ro = ro;
    }

    setupCanvas() {
      if (!this.canvas) return;
      this.canvas.preserveObjectStacking = true;
      this.canvas.controlsAboveOverlay = true;
      this.canvas.selection = true;
    }

    setupEventListeners() {
      window.addEventListener(
        "resize",
        debounce(() => this.handleResize(), 300)
      );

      document.addEventListener("keydown", (e) => {
        const obj = this.canvas?.getActiveObject();
        if (!obj) return;
        const mod = e.ctrlKey || e.metaKey;

        if (mod && e.key === "]") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const maxIdx = this._topCeilingIndex();
          if (cur < maxIdx) this.canvas.bringForward(obj);
          this._guardZ(obj);
          e.preventDefault();
        } else if (mod && e.key === "[") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const minIdx = this._bgTopIndex() + 1;
          if (cur > minIdx) this.canvas.sendBackwards(obj);
          this._guardZ(obj);
          e.preventDefault();
        }
      });

      const getStartedBtn = document.getElementById("get-started-btn");
      if (getStartedBtn) {
        getStartedBtn.addEventListener("click", async () => {
          const designerTool = document.getElementById("designerTool");
          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
            await this.renderCardFromState(state.currentCard);
          }
        });
      }
      const closeBtn = document.getElementById("designer-tool-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.add("active");
        });
      }
      const cancelClose = document.getElementById("cancel-close-tool");
      if (cancelClose) {
        cancelClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.remove("active");
        });
      }
      const confirmClose = document.getElementById("confirm-close-tool");
      if (confirmClose) {
        confirmClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          const designerTool = document.getElementById("designerTool");
          if (popup) popup.classList.remove("active");
          if (designerTool) {
            designerTool.classList.remove("active");
            enableBodyScroll();
          }
        });
      }
      const toggleGuides = document.getElementById("toggleGuides");
      if (toggleGuides) {
        toggleGuides.addEventListener("change", (e) => {
          this.toggleGuidelines(e.target.checked);
        });
      }
      const toggleSnap = document.getElementById("toggleSnap");
      if (toggleSnap) {
        toggleSnap.addEventListener("change", (e) => {
          this.snappingEnabled = e.target.checked;
        });
      }
      const btnEditImage = document.getElementById("btnEditImage");
      if (btnEditImage) {
        btnEditImage.addEventListener("click", async () => {
          const designerTool = document.getElementById("designerTool");
          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
            await this.renderCardFromState(state.currentCard);
          }
        });
      }
      document
        .querySelectorAll(".align-btn")
        .forEach((btn) =>
          btn.addEventListener("click", (e) =>
            this.alignObjects(e.currentTarget.dataset.align)
          )
        );
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.addEventListener("click", () => this.finishEditing());
      }

      const handleSelection = (e) => {
        const onlyOne = e.selected && e.selected.length === 1;
        if (onlyOne) {
          const obj = e.selected[0];
          const suf = state.currentCard === 1 ? "c1" : "c2";
          let targetId =
            obj === this.backgroundImage ? `image-variant-${suf}` : null;
          if (targetId) {
            const targetEl = document.getElementById(targetId);
            if (targetEl) {
              const scroller = findScrollableParent(targetEl);
              if (scroller) {
                const rectTarget = targetEl.getBoundingClientRect();
                const rectScroller = scroller.getBoundingClientRect();
                const offset = rectTarget.top - rectScroller.top;
                const centering =
                  scroller.clientHeight / 2 - rectTarget.height / 2;
                const scrollToPos = scroller.scrollTop + offset - centering;
                scroller.scrollTo({ top: scrollToPos, behavior: "smooth" });
              } else {
                targetEl.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }
          }
        }
      };
      this.canvas.on("selection:created", handleSelection);
      this.canvas.on("selection:updated", handleSelection);
      this.canvas.on("selection:cleared", () => {});
      this.canvas.on("object:modified", () => {
        if (typeof saveCurrentCardState === "function") {
          saveCurrentCardState();
        }
      });
      this.canvas.on("object:moving", (e) => {
        if (!this.snappingEnabled || !this.clipPath) return;

        const obj = e.target;
        if (!obj) return;

        const threshold = 10;
        const cur = obj.getCenterPoint();
        const clipBR = this.clipPath.getBoundingRect(true);
        const clipCX = clipBR.left + clipBR.width / 2;
        const clipCY = clipBR.top + clipBR.height / 2;

        let targetCX = cur.x;
        let targetCY = cur.y;

        if (Math.abs(cur.x - clipCX) <= threshold) targetCX = clipCX;
        if (Math.abs(cur.y - clipCY) <= threshold) targetCY = clipCY;

        obj.setPositionByOrigin(
          new fabric.Point(targetCX, targetCY),
          "center",
          "center"
        );
        obj.setCoords();

        this.canvas.requestRenderAll();
      });

      this.canvas.on("object:added", (e) => {
        if (this.guidelineObjects.length) this._bringGuidesToFront();
      });
    }

    setupCustomControls() {
      const preload = (src) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });

      Promise.all([
        preload(this.icons.resizeLeft),
        preload(this.icons.resizeRight),
        preload(this.icons.resizeHorizontal),
        preload(this.icons.stackUp),
        preload(this.icons.stackDown),
        preload(this.icons.rotate),
      ])
        .then(
          ([
            resizeLeftImg,
            resizeRightImg,
            resizeHImg,
            stackUpImg,
            stackDownImg,
            rotateImg,
          ]) => {
            this.applyCustomCornerIcons(
              resizeLeftImg,
              resizeRightImg,
              resizeHImg,
              stackUpImg,
              stackDownImg,
              rotateImg
            );
          }
        )
        .catch((e) => console.warn("Icon preload failed:", e));

      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "black";
      fabric.Object.prototype.borderColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    applyCustomCornerIcons(
      iconLeft,
      iconRight,
      iconHorizontal,
      iconStackUp,
      iconStackDown,
      iconRotate
    ) {
      const renderIcon = (icon) =>
        function (ctx, left, top, _style, fabricObject) {
          const size = this.cornerSize || 24;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
          ctx.drawImage(icon, -size / 2, -size / 2, size, size);
          ctx.restore();
        };

      const setCtrl = (key, opts) => {
        const ctrl = fabric.Object.prototype.controls[key];
        if (ctrl) Object.assign(ctrl, opts);
      };

      const cornerSize = 25;
      setCtrl("tl", { render: renderIcon(iconLeft), cornerSize });
      setCtrl("tr", { render: renderIcon(iconRight), cornerSize });
      setCtrl("bl", { render: renderIcon(iconRight), cornerSize });
      setCtrl("br", { render: renderIcon(iconLeft), cornerSize });

      const midSize = 25;
      setCtrl("ml", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });
      setCtrl("mr", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });

      fabric.Object.prototype.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      });

      const ICON_SIZE = 25;
      const OFFSET_X = 25;
      const OFFSET_Y = 12;
      const GAP_Y = 6;

      const makeTopRightControl = (name, order, iconImg, onClick) => {
        fabric.Object.prototype.controls[name] = new fabric.Control({
          x: 0.5,
          y: -0.5,
          offsetX: OFFSET_X,
          offsetY: OFFSET_Y + order * (ICON_SIZE + GAP_Y),
          cornerSize: ICON_SIZE,
          cursorStyle: "pointer",
          render: renderIcon(iconImg),
          mouseUpHandler: (_evt, transform) => {
            const obj = transform.target;
            if (!obj || !obj.canvas) return;
            onClick(obj);
            this._guardZ(obj);
            obj.canvas.setActiveObject(obj);
            obj.canvas.requestRenderAll();
          },
        });
      };

      makeTopRightControl("bringFwd", 0, iconStackUp, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const maxIdx = this._topCeilingIndex();
        if (cur < maxIdx) obj.canvas.bringForward(obj);
      });

      makeTopRightControl("sendBack", 1, iconStackDown, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const minIdx = this._bgTopIndex() + 1;
        if (cur > minIdx) obj.canvas.sendBackwards(obj);
      });

      const ROTATE_SIZE = 26;
      const ROTATE_OFFSETY = -32;

      fabric.Object.prototype.controls.mtr = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetY: ROTATE_OFFSETY,
        cornerSize: ROTATE_SIZE,
        cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: "rotate",
        render: renderIcon(iconRotate),
        withConnection: true,
        connectionStyle: { stroke: "#000", strokeWidth: 1 },
      });
    }

    _topCeilingIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let minGuide = Infinity;
      this.guidelineObjects.forEach((g) => {
        const idx = objs.indexOf(g);
        if (idx !== -1) minGuide = Math.min(minGuide, idx);
      });
      return minGuide === Infinity ? objs.length - 1 : minGuide - 1;
    }

    _bringGuidesToFront() {
      if (!this.canvas) return;
      this.guidelineObjects.forEach((g) => this.canvas.bringToFront(g));
      this.canvas.requestRenderAll();
    }

    _bgTopIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let idx = -1;
      if (this.backgroundRect)
        idx = Math.max(idx, objs.indexOf(this.backgroundRect));
      if (this.backgroundImage)
        idx = Math.max(idx, objs.indexOf(this.backgroundImage));
      if (this.chipImage) idx = Math.max(idx, objs.indexOf(this.chipImage));
      if (this.stripRect) idx = Math.max(idx, objs.indexOf(this.stripRect));
      return idx;
    }

    _guardZ(obj) {
      if (!this.canvas || !obj) return;

      if (this.guidelineObjects?.length) this._bringGuidesToFront();

      const objs = this.canvas.getObjects();
      const bgTop = this._bgTopIndex();
      const topCap = this._topCeilingIndex();

      let cur = objs.indexOf(obj);
      if (bgTop >= 0 && cur <= bgTop) this.canvas.moveTo(obj, bgTop + 1);

      cur = objs.indexOf(obj);
      if (topCap >= 0 && cur > topCap) this.canvas.moveTo(obj, topCap);

      this.canvas.requestRenderAll();
    }

    ppiX() {
      if (!this.clipPath) return 1;
      const { width } = this.getCardSize();
      return this.clipPath.width / width;
    }

    ppiY() {
      if (!this.clipPath) return 1;
      const { height } = this.getCardSize();
      return this.clipPath.height / height;
    }

    _buildCardClipPath({ left, top, widthPx, heightPx }) {
      const { width: wIn, height: hIn } = this.getCardSize();
      const sx = widthPx / wIn;
      const sy = heightPx / hIn;

      const rectClip = new fabric.Rect({
        left,
        top,
        width: widthPx,
        height: heightPx,
        rx: 20, // Added for rounded corners
        ry: 20, // Added for rounded corners
        absolutePositioned: true,
      });

      return { rectClip };
    }

    handleResize() {
      if (!this.canvas) return;
      this.updateCanvasSize();
      this.drawClipPath();
      this.canvas.renderAll();
    }

    updateCanvasSize() {
      const container = document.getElementById("canvasContainer");
      if (!container || !this.canvas) return;
      if (container.clientWidth === 0 && container.clientHeight === 0) return;

      const width = Math.max(1, container.clientWidth || 1);
      const small = window.matchMedia("(max-width: 640px)").matches;

      const ratio = 3.375 / 2.125;

      let height;

      if (small) {
        height = Math.max(120, Math.round(width / ratio));
        const nearSquare = ratio >= 0.9 && ratio <= 1.1;
        const midSquare = ratio > 0.75 && ratio < 1.33;
        const shrink = nearSquare ? 0.75 : midSquare ? 0.85 : 0.9;
        height = Math.round(height * shrink);
        const maxVH = Math.floor(window.innerHeight * 0.4);
        height = Math.min(height, maxVH);
      } else {
        height = Math.max(
          1,
          container.clientHeight || Math.round(width / ratio)
        );
      }

      this.canvas.setDimensions({ width, height });
      this.canvas.calcOffset();
      this.canvas.renderAll();
    }

    getCardSize() {
      return { width: 3.375, height: 2.125 };
    }

    mobileFillForRatio(ratio) {
      if (ratio >= 0.9 && ratio <= 1.1) return 0.7; // Adjusted for smaller clip path
      if (ratio >= 1.6 || ratio <= 0.625) return 0.7; // Adjusted for smaller clip path
      return 0.7; // Adjusted for smaller clip path
    }

    hasContent() {
      const cardState = state[`card${state.currentCard}`];
      return !!cardState.imageUrl;
    }

    updateFinishButtonState() {
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.disabled = !this.hasContent();
      }
    }

    _snapshotObj(obj) {
      if (!obj || !this.clipPath) return null;
      const b = this.clipPath.getBoundingRect(true);
      return {
        cx: (obj.left - b.left) / b.width,
        cy: (obj.top - b.top) / b.height,
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        angle: obj.angle || 0,
        originX: obj.originX || "center",
        originY: obj.originY || "center",
        clipW: b.width,
        clipH: b.height,
      };
    }

    _applySnapshot(obj, snap) {
      if (!obj || !snap || !this.clipPath) return;
      const b = this.clipPath.getBoundingRect(true);
      const kx = b.width / (snap.clipW || b.width);
      const ky = b.height / (snap.clipH || b.height);

      obj.set({
        left: b.left + snap.cx * b.width,
        top: b.top + snap.cy * b.height,
        originX: snap.originX,
        originY: snap.originY,
        scaleX: (snap.scaleX || 1) * kx,
        scaleY: (snap.scaleY || 1) * ky,
        angle: snap.angle || 0,
      });
      obj.setCoords();
    }

    drawClipPath() {
      if (!this.canvas) return;
      if (this.freezeLayout && this.clipPath && this.backgroundRect) return;

      const container = document.getElementById("canvasContainer");
      if (!container) return;

      if (container.clientWidth === 0 || container.clientHeight === 0) {
        this.canvas.clear();
        this.canvas.clipPath = null;
        this.canvas.renderAll();
        return;
      }

      // after: keep chip and strip overlays too
      const keep = [this.backgroundImage, this.chipImage, this.stripRect].filter(Boolean);

      let old = null;
      if (this.clipPath) {
        old = {
          left: this.clipPath.left,
          top: this.clipPath.top,
          w: this.clipPath.width,
          h: this.clipPath.height,
        };
      }

      this.canvas.clear();
      this.canvas.clipPath = null;

      const { width: wIn, height: hIn } = this.getCardSize();
      const ratio = wIn / hIn;
      const small = window.matchMedia("(max-width: 640px)").matches;
      const fill = small ? this.mobileFillForRatio(ratio) : 0.6; // Adjusted for smaller clip path

      const maxW = container.clientWidth * fill;
      const maxH = container.clientHeight * fill;

      const widthPx = ratio > maxW / maxH ? maxW : maxH * ratio;
      const heightPx = ratio > maxW / maxH ? maxW / ratio : maxH;

      const centerX = this.canvas.getWidth() / 2;
      const centerY = this.canvas.getHeight() / 2;
      const left = centerX - widthPx / 2;
      const top = centerY - heightPx / 2;

      if (!this.backgroundRect) {
        this.backgroundRect = new fabric.Rect({
          left,
          top,
          width: widthPx,
          height: heightPx,
          fill: "white",
          selectable: false,
          evented: false,
          rx: 20, // Added for rounded corners
          ry: 20, // Added for rounded corners
        });
        this.canvas.add(this.backgroundRect);
      } else {
        this.backgroundRect.set({
          left,
          top,
          width: widthPx,
          height: heightPx,
          rx: 20, // Added for rounded corners
          ry: 20, // Added for rounded corners
        });
        this.canvas.add(this.backgroundRect);
      }

      const { rectClip } = this._buildCardClipPath({
        left,
        top,
        widthPx,
        heightPx,
      });
      this.clipPath = rectClip;
      this.canvas.clipPath = this.clipPath;

      const scale = old ? widthPx / old.w : 1;
      keep.forEach((obj) => {
        this.canvas.add(obj);
        if (old) {
          const relX = (obj.left - old.left) / old.w;
          const relY = (obj.top - old.top) / old.h;
          obj.set({
            left: left + relX * widthPx,
            top: top + relY * heightPx,
            scaleX: obj.scaleX * scale,
            scaleY: obj.scaleY * scale,
          });
        }
        obj.setCoords();
      });

      this._drawGuides();

      if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
      if (this.backgroundRect) this.canvas.sendToBack(this.backgroundRect);
      if (this.chipImage) this.canvas.bringToFront(this.chipImage);
      if (this.stripRect) this.canvas.bringToFront(this.stripRect);

      this.canvas.renderAll();
      this.updateFinishButtonState();
    }

    _drawGuides() {
      this.guidelineObjects.forEach((o) => this.canvas.remove(o));
      this.guidelineObjects = [];

      const show = document.getElementById("toggleGuides")?.checked || false;
      if (!show || !this.clipPath) return;

      const left = this.clipPath.left;
      const top = this.clipPath.top;
      const wPx = this.clipPath.width;
      const hPx = this.clipPath.height;
      const sx = this.ppiX();
      const sy = this.ppiY();

      const inset = 0;
      const rectGuide = new fabric.Rect({
        left: left + inset * sx,
        top: top + inset * sy,
        width: wPx - 2 * inset * sx,
        height: hPx - 2 * inset * sy,
        fill: "transparent",
        stroke: "#ec008c",
        strokeWidth: 1,
        strokeDashArray: [6, 3],
        selectable: false,
        evented: false,
        strokeUniform: true,
        rx: 20, // Added for rounded corners
        ry: 20, // Added for rounded corners
      });

      this.canvas.add(rectGuide);
      this.guidelineObjects.push(rectGuide);
      this.canvas.renderAll();
    }

    async renderCardFromState(cardIndex) {
      const cs = state[`card${cardIndex}`] || {};
      const token = ++this._renderToken;

      this.canvas.clear();
      this.canvas.clipPath = null;
      this.backgroundRect = null;
      this.backgroundImage = null;
      this.chipImage = null;
      this.stripRect = null;
      this.guidelineObjects = [];

      this.drawClipPath();

      if (cs.imageUrl) {
        await new Promise((resolve) => {
          fabric.Image.fromURL(
            cs.imageUrl,
            (img) => {
              if (token !== this._renderToken) return resolve();
              this._placeImage(img, cs.imageTransform || null);
              resolve();
            },
            { crossOrigin: "anonymous" }
          );
        });
      }

      if (cardIndex === 1) {
        this.updateChipSize(cs.chipSize || "Large Chip");
      } else if (cardIndex === 2) {
        this.updateStrip(cs.strip || "No Strip");
      }

      this.canvas.renderAll();
      this.updateFinishButtonState();
    }

    _exportCardPng(multiplier = 2) {
      if (!this.clipPath) return "";
      const { left, top, width, height } = this.clipPath;
      return this.canvas.toDataURL({
        left,
        top,
        width,
        height,
        format: "png",
        multiplier,
      });
    }

    toggleGuidelines(visible) {
      if (!this.canvas) return;
      this.guidelineObjects.forEach((obj) => {
        obj.visible = visible;
        obj.set({ visible });
      });
      this.canvas.renderAll();
    }

    alignObjects(direction) {
      if (!this.canvas || !this.clipPath) return;
      const activeObjects = this.canvas.getActiveObjects();
      if (!activeObjects.length) return;
      if (activeObjects.length === 1) {
        const bounds = this.clipPath.getBoundingRect(true);
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: bounds.left + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: bounds.left + bounds.width / 2 });
              break;
            case "right":
              obj.set({
                left: bounds.left + bounds.width - obj.getScaledWidth() / 2,
              });
              break;
            case "top":
              obj.set({ top: bounds.top + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: bounds.top + bounds.height / 2 });
              break;
            case "bottom":
              obj.set({
                top: bounds.top + bounds.height - obj.getScaledHeight() / 2,
              });
              break;
          }
          obj.setCoords();
        });
      } else {
        let minLeft = Infinity,
          maxRight = -Infinity,
          minTop = Infinity,
          maxBottom = -Infinity;
        let totalCenterX = 0,
          totalCenterY = 0;
        activeObjects.forEach((obj) => {
          const bound = obj.getBoundingRect(true);
          minLeft = Math.min(minLeft, bound.left);
          maxRight = Math.max(maxRight, bound.left + bound.width);
          minTop = Math.min(minTop, bound.top);
          maxBottom = Math.max(maxBottom, bound.top + bound.height);
          totalCenterX += bound.left + bound.width / 2;
          totalCenterY += bound.top + bound.height / 2;
        });
        const avgCenterX = totalCenterX / activeObjects.length;
        const avgCenterY = totalCenterY / activeObjects.length;
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: minLeft + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: avgCenterX });
              break;
            case "right":
              obj.set({ left: maxRight - obj.getScaledWidth() / 2 });
              break;
            case "top":
              obj.set({ top: minTop + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: avgCenterY });
              break;
            case "bottom":
              obj.set({ top: maxBottom - obj.getScaledHeight() / 2 });
              break;
          }
          obj.setCoords();
        });
      }
      this.canvas.renderAll();
    }

    updateChipSize(chipSize) {
      if (state.currentCard !== 1 || !this.canvas || !this.clipPath) return;
      state.card1.chipSize = chipSize;

      if (this.chipImage) {
        this.canvas.remove(this.chipImage);
        this.chipImage = null;
      }

      if (chipSize === "No Chip") {
        this.drawClipPath();
        return;
      }

      const { width: wIn, height: hIn } = this.getCardSize();
      const sx = this.ppiX();
      const sy = this.ppiY();
      const CHIP_WIDTH_IN = chipSize === "Large Chip" ? 0.5 : 0.375;
      const CHIP_HEIGHT_IN = chipSize === "Large Chip" ? 0.375 : 0.25;
      const CHIP_LEFT_IN = 0.375;
      const CHIP_TOP_IN = 0.725;

      fabric.Image.fromURL(
        "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/chip.png",
        (img) => {
          if (!img || !this.clipPath) {
            // Fallback to grey rectangle if image fails to load
            const chipRect = new fabric.Rect({
              left: this.clipPath.left + CHIP_LEFT_IN * sx,
              top: this.clipPath.top + CHIP_TOP_IN * sy,
              width: CHIP_WIDTH_IN * sx,
              height: CHIP_HEIGHT_IN * sy,
              fill: "#808080", // Grey fallback color
              selectable: false,
              evented: false,
            });
            this.canvas.add(chipRect);
            this.chipImage = chipRect;
            console.warn(
              "Failed to load chip image, using grey rectangle as fallback."
            );
          } else {
            img.set({
              left: this.clipPath.left + CHIP_LEFT_IN * sx,
              top: this.clipPath.top + CHIP_TOP_IN * sy,
              scaleX: (CHIP_WIDTH_IN * sx) / img.width,
              scaleY: (CHIP_HEIGHT_IN * sy) / img.height,
              selectable: false,
              evented: false,
            });
            this.canvas.add(img);
            this.chipImage = img;
          }
          this.canvas.bringToFront(this.chipImage);
          this.canvas.renderAll();
          this.drawClipPath(); // Re-draw clip path to apply chip cutout
        },
        {
          crossOrigin: "anonymous",
          onError: (err) => {
            console.error("Error loading chip image:", err);
            // Fallback to grey rectangle
            const chipRect = new fabric.Rect({
              left: this.clipPath.left + CHIP_LEFT_IN * sx,
              top: this.clipPath.top + CHIP_TOP_IN * sy,
              width: CHIP_WIDTH_IN * sx,
              height: CHIP_HEIGHT_IN * sy,
              fill: "#808080", // Grey fallback color
              selectable: false,
              evented: false,
            });
            this.canvas.add(chipRect);
            this.chipImage = chipRect;
            this.canvas.bringToFront(this.chipImage);
            this.canvas.renderAll();
            this.drawClipPath();
          },
        }
      );
    }

    updateStrip(strip) {
      if (state.currentCard !== 2 || !this.canvas || !this.clipPath) return;
      state.card2.strip = strip;

      if (this.stripRect) {
        this.canvas.remove(this.stripRect);
        this.stripRect = null;
      }

      if (strip === "No Strip") {
        this.drawClipPath();
        return;
      }

      const { width: wIn, height: hIn } = this.getCardSize();
      const sx = this.ppiX();
      const sy = this.ppiY();
      const STRIP_HEIGHT_IN = 0.5;
      const STRIP_TOP_IN = 0.25;

      const stripRect = new fabric.Rect({
        left: this.clipPath.left,
        top: this.clipPath.top + STRIP_TOP_IN * sy,
        width: this.clipPath.width,
        height: STRIP_HEIGHT_IN * sy,
        fill: "#000000",
        selectable: false,
        evented: false,
      });

      this.canvas.add(stripRect);
      this.stripRect = stripRect;
      this.canvas.bringToFront(this.stripRect);
      this.drawClipPath();
    }

    _placeImage(img, snap = null) {
      if (!this.canvas || !this.clipPath) return;

      const centerX = this.canvas.getWidth() / 2;
      const centerY = this.canvas.getHeight() / 2;
      const clipW = this.clipPath.width;
      const clipH = this.clipPath.height;

      if (!snap) {
        const scale = Math.max(clipW / img.width, clipH / img.height);
        img.set({
          scaleX: scale,
          scaleY: scale,
          originX: "center",
          originY: "center",
          left: centerX,
          top: centerY,
        });
      } else {
        img.set({ originX: "center", originY: "center" });
      }

      img.set({
        selectable: true,
        evented: true,
        hasControls: true,
        hasBorders: true,
      });
      img.setCoords();

      if (this.backgroundImage) this.canvas.remove(this.backgroundImage);
      this.canvas.add(img);
      this.backgroundImage = img;

      if (snap) this._applySnapshot(img, snap);

      this.canvas.sendToBack(this.backgroundImage);
      if (this.backgroundRect) this.canvas.sendToBack(this.backgroundRect);
      if (this.chipImage) this.canvas.bringToFront(this.chipImage);
      if (this.stripRect) this.canvas.bringToFront(this.stripRect);
      this.canvas.renderAll();
      this.updateFinishButtonState();
    }

    handleImageUpload(event, explicitCardIdx = null) {
      const file = event.target.files?.[0];
      if (!file) return;

      const targetCard = explicitCardIdx ?? state.currentCard;

      if (!this.canvas || !this.clipPath) this.drawClipPath();

      const reader = new FileReader();
      reader.onload = (e) => {
        const url = e.target.result;

        const cs = state[`card${targetCard}`];
        cs.imageUrl = url;
        cs.image = file;

        if (state.currentCard === targetCard) {
          const renderTokenAtUpload = this._renderToken;
          fabric.Image.fromURL(
            url,
            (img) => {
              if (renderTokenAtUpload !== this._renderToken) return;
              this._placeImage(img);
              cs.imageTransform = this._snapshotObj(this.backgroundImage);
              this.canvas.renderAll();
            },
            { crossOrigin: "anonymous" }
          );
        }
      };
      reader.readAsDataURL(file);
    }

    async finishEditing() {
      const originalCard = state.currentCard;
      try {
        if (!this.canvas || !this.clipPath) this.drawClipPath();

        state.currentCard = 1;
        await this.renderCardFromState(1);
        await new Promise((resolve) => setTimeout(resolve, 300));
        this.canvas.renderAll();
        this.guidelineObjects.forEach((g) => (g.visible = false));
        this.canvas.renderAll();
        const dataURL1 = this._exportCardPng();
        state.editedCard1 = dataURLtoFile(dataURL1, "front-card.png");
        const previewImage1 = document.getElementById("preview-image1");
        if (previewImage1) previewImage1.src = dataURL1;

        const previewImage2 = document.getElementById("preview-image2");
        const preview2Wrap = document.querySelector(".card-preview2");

        if (state.customizeBack && isCardCustomized(state.card2)) {
          state.currentCard = 2;
          await this.renderCardFromState(2);
          await new Promise((resolve) => setTimeout(resolve, 300));
          this.canvas.renderAll();
          this.guidelineObjects.forEach((g) => (g.visible = false));
          this.canvas.renderAll();
          const dataURL2 = this._exportCardPng();
          state.editedCard2 = dataURLtoFile(dataURL2, "back-card.png");
          if (previewImage2) previewImage2.src = dataURL2;
          if (preview2Wrap) preview2Wrap.style.display = "block";
        } else {
          state.editedCard2 = null;
          if (previewImage2) previewImage2.src = "";
          if (preview2Wrap) preview2Wrap.style.display = "none";
        }

        // NEW: if user confirmed back but didn't upload anything, revert back customization and price
        if (state.customizeBack && !isCardCustomized(state.card2)) {
          // turn off back customization and remove the extra charge
          state.customizeBack = false;
          state.extraForBack = 0;
          recalcPrice();

          // hide back-side UI
          const imageVariantC2 = document.getElementById("image-variant-c2");
          const variantsC2 = document.getElementById("variants-c2");
          if (imageVariantC2) imageVariantC2.style.display = "none";
          if (variantsC2) variantsC2.style.display = "none";

          // reset back-side state
          state.card2 = {
            image: null,
            imageUrl: null,
            strip: "No Strip",
            imageTransform: null,
          };

          // clean any leftover overlay on the canvas (strip, etc.)
          if (this.stripRect) {
            this.canvas.remove(this.stripRect);
            this.stripRect = null;
          }
        }

        state.currentCard = originalCard;
        await this.renderCardFromState(originalCard);

        const designerTool = document.getElementById("designerTool");
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const uploadArtbox = document.getElementById("upload-artbox");
        if (designerTool) designerTool.classList.remove("active");
        enableBodyScroll();
        if (previewBox) previewBox.style.display = "block";
        if (mainVariants) mainVariants.classList.add("active");
        if (uploadArtbox) uploadArtbox.style.display = "none";
      } catch (err) {
        console.error("Error saving edited image:", err);
        this.showError("Failed to save edited image. Please try again.");
      } finally {
        state.currentCard = originalCard;
        const toggleGuides = document.getElementById("toggleGuides");
        const shouldShowGuides = toggleGuides ? toggleGuides.checked : false;
        if (this.guidelineObjects.length > 0) {
          this.guidelineObjects.forEach((g) => (g.visible = shouldShowGuides));
          this.canvas.renderAll();
        }
      }
    }

    handleRemoveAllImproved() {
      if (this.canvas) {
        this.canvas.clear();
        this.canvas.clipPath = null;

        this.clipPath = null;
        this.backgroundRect = null;
        this.backgroundImage = null;
        this.chipImage = null;
        this.stripRect = null;
        this.guidelineObjects = [];

        this.drawClipPath();

        const cardState = state[`card${state.currentCard}`];
        if (state.currentCard === 1) {
          this.updateChipSize(cardState.chipSize || "Large Chip");
        } else {
          this.updateStrip(cardState.strip || "No Strip");
        }
      }
    }

    showError(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("warning");
        msgEl.classList.add("error");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }

    showWarning(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("error");
        msgEl.classList.add("warning");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }
  }

  // =============================================
  // 15. INITIALIZE EVERYTHING
  // =============================================
  function initialize() {
    designer = new CardDesigner();
    bindUploadForCard(1);
    bindUploadForCard(2);
    setupChipSizeSelection();
    setupStripSelection();
    setupEnhanceSelection();
    setupMaterialSelection();
    setupQuantitySelection();
    handleNotesInput();
    setupApippaAddToCart();
    setupCardSwitching();
    document.getElementById("image-variant-c2").style.display =
      state.customizeBack ? "" : "none";
    document.getElementById("variants-c2").style.display = state.customizeBack
      ? ""
      : "none";
    document.getElementById("image-variant-c1").style.display = "";
    document.getElementById("variants-c1").style.display = "";
    recalcPrice();
    loadCurrentCardState();
  }
  initialize();
});
